import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

export const usePermissionGuard = () => {
  const myInfo = useSelector((state) => state.general?.myInfo || null);
  const isProjectOpenForCollaboration = useSelector(
    (state) => state.general?.isProjectOpenForCollaboration || false
  );
  // const myInfo = {
  //   id: 85,
  //   name: "Riaz Ali",
  //   user_name: "next@petech.com",
  //   avatar:
  //     "https://dentalidlaravel.s3.me-central-1.amazonaws.com/https://staging.enterprise.daapi.dentalid.app/images/no_avatar.png",
  //   speciality: "",
  //   canManageAmCases: false,
  //   canManagePmCases: false,
  //   examiner_type: "primary",
  //   status: "accepted",
  //   created_at: "2025-06-27 06:21:12",
  // };
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (isProjectOpenForCollaboration) return;

    if (!myInfo) {
      navigate("/dental-identification/permission-denied", { replace: true });
      return;
    }
    const { pathname, search } = location;
    const params = new URLSearchParams(search);
    const caseTypeFromQuery = params.get("case_type");

    const isAmPage =
      pathname.includes("/case-registration/am") ||
      (pathname.includes("/add-dental-record") && caseTypeFromQuery === "am");

    const isPmPage =
      pathname.includes("/case-registration/pm") ||
      (pathname.includes("/add-dental-record") && caseTypeFromQuery === "pm");

    if (isAmPage && !myInfo?.canManageAmCases) {
      navigate("/dental-identification/permission-denied", { replace: true });
    } else if (isPmPage && !myInfo?.canManagePmCases) {
      navigate("/dental-identification/permission-denied", { replace: true });
    }
  }, [location, myInfo, location.search, navigate]);
};
